export default __webpack_public_path__ + "static/media/ilustracao-homem-comemorando-sorteio-withoutBG.264a6b1d.svg";